

import {useCurrent } from '../../../hooks'
import ProfessionalChartLoader from '../../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { createList } from '../../../../../common/utils/graph.utils'
import { formatDateByPeriod } from '../../../../../common/utils/dateFormatter'
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView'


export default function CurrentChartPresenter() {
    const { filter,  currentQuery:query}= useCurrent()


      
    if(query.isLoading) {
      return <ProfessionalChartLoader metricName="Courant" />
  }
  
  if(query.isError && query.error) {
    const error = query.error as Error

    return <ChartErrorView metricName="Courant" error={error} />
  }
  
  const dataChart = createList(filter.aggregateWindow || '1mo', filter, query.data)
    return (
      <ChartLineView
  
  
        xAxisData ={dataChart.listx.map((item) => formatDateByPeriod(item, filter.aggregateWindow || '1mo'))}
        data ={dataChart.listValue}
        label='Courant (A)'
        unit='A'
  
      />
    )
}